/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as SetDefs from './defs.defs.js'

const $nsid = 'tools.ozone.set.getValues'

export { $nsid }

/** Get a specific set and its values */
const main = l.query(
  $nsid,
  l.params({
    name: l.string(),
    limit: l.optional(
      l.withDefault(l.integer({ minimum: 1, maximum: 1000 }), 100),
    ),
    cursor: l.optional(l.string()),
  }),
  l.jsonPayload({
    set: l.ref<SetDefs.SetView>((() => SetDefs.setView) as any),
    values: l.array(l.string()),
    cursor: l.optional(l.string()),
  }),
  ['SetNotFound'],
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
